import { gql } from '@apollo/client';
const GET_WAREHOUSE_RELEASES = gql `
  query GetWarehouseReleases(
    $orderBy: String
    $statuses: [String]
    $search: String
    $first: Int
    $after: String
  ) {
    me {
      id
      warehouseReleasesCount(statuses: $statuses, search: $search)
      warehouseReleases(
        orderBy: $orderBy
        statuses: $statuses
        search: $search
        first: $first
        after: $after
      ) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            releaseId
            status
            createdDate
            modifiedDate
            remarks
            receiver
            sumOfModelQuantities
            allComponentVariantsReady
            warehouseReleaseModel {
              ready
              modelSpecification {
                id
                itemCode
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_WAREHOUSE_RELEASES;
